import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
// import { Component } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Device } from '@twilio/voice-sdk';

import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Device } from '@twilio/voice-sdk';
@Component({
  selector: 'calsoft-phone-dialer',
  templateUrl: './phone-dialer.component.html',
  styleUrls: ['./phone-dialer.component.scss']
})
export class PhoneDialerComponent {

  phoneNumber: string = '';
  callStatus: string = 'ℹ️ Device not initialized';
  private device?: Device;
  private connection?: any;
  currentCall: any = undefined;
  deviceConnectionStatus: string = 'Intilize';
  logs: string[] = [];

  url = '';
  sanitizedUrl = '';

  constructor(private http: HttpClient, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
  }

  private log(message: string) {
    console.log(message);
    this.logs.unshift(`${new Date().toLocaleTimeString()} — ${message}`);
  }

  initDevice() {
    this.http
      .get<{ token: string }>(
        'http://localhost:7013/ecom-svc-whatsapp-1.0-SNAPSHOT/api/call/token?to=919033838405'
      )
      .subscribe({
        next: (res) => {
          this.device = new Device(res.token, { logLevel: 1 });

          this.device.on('registered', () => {
            this.callStatus = '✅ Device registered';
            this.log(this.callStatus);
          });

          this.device.on('unregistered', () => {
            this.callStatus = '❌ Device unregistered';
            this.log(this.callStatus);
          });

          this.device.on('connect', (conn) => {
            this.callStatus = '🔗 Call connected';
            this.connection = conn;
            this.log(this.callStatus);
          });


          this.device.on('disconnect', () => {
            this.callStatus = '🔚 Call disconnected';
            this.connection = undefined;
            this.log(this.callStatus);
          });
          this.device.on('error', (err) => {
            this.callStatus = '⚠️ Device error';
            this.log(`Error: ${JSON.stringify(err)}`);
            alert(JSON.stringify(err, null, 2));
          });

          this.device.on('tokenWillExpire', () => {
            this.http
              .get<{ token: string }>(
                'http://localhost:7013/ecom-svc-whatsapp-1.0-SNAPSHOT/api/call/token?to=919033838405'
              )
              .subscribe((newRes) => {
                this.device?.updateToken(newRes.token);
                this.log('🔄 Token refreshed');
              });
          });

          this.device.register();
          this.callStatus = '⚙️ Device initializing...';
          this.log(this.callStatus);
        },
        error: (err) => {
          this.callStatus = '❌ Failed to init device';
          this.log(`Init error: ${JSON.stringify(err)}`);
        }
      });
  }
  call() {
    if (!this.device) {
      this.callStatus = '⚠️ Initializing device...';
      this.log(this.callStatus);
      this.initDevice();
      setTimeout(() => this.call(), 1000);
      return;
    }

    if (!this.phoneNumber.trim()) {
      this.callStatus = '⚠️ Enter a phone number first';
      this.log(this.callStatus);
      return;
    }

    this.callStatus = `📞 Calling ${this.phoneNumber}...`;
    this.log(this.callStatus);


    this.device.connect({ params: { To: this.phoneNumber } })
      .then(call => {

        this.currentCall = call;

        call.on('accept', () => {
          this.callStatus = '🔗 Call Connected';
          this.log(this.callStatus);
        });
        call.on('ringing', (hasEarlyMedia) => {
          this.callStatus = 'Ringing...';
          this.log(this.callStatus);
        });
        call.on('reject', () => {
          this.callStatus = 'Call was rejected';
          this.log(this.callStatus);
        });
        call.on('disconnect', () => {
          this.callStatus = '🔚 Call disconnected';
          this.log(this.callStatus);
        });
        call.on('cancel', () => {
          this.callStatus = 'Call was not answered';
          this.log(this.callStatus);
        });
        call.on('error', (err) => {
          this.callStatus = '⚠️ Call error';
          this.log(this.callStatus);

        });

      })
  }

  hangup() {
    if (this.currentCall) {
      this.log('⏹ Hangup requested');
      this.currentCall.disconnect();
      this.currentCall = undefined;
    }
  }


  addDigit(digit: string) {
    this.phoneNumber = (this.phoneNumber || '') + digit;
  }

  backspace() {
    this.phoneNumber = (this.phoneNumber || '').slice(0, -1);
  }

  clearNumber() {
    this.phoneNumber = '';
  }


  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').toLowerCase();
  }
}
